<script>
export default {
  name: 'TopSellingItemChart',
  props: {
    chartData: {
      type: Array,
      required: true
    },
    chartConfig: {
      type: Object,
      default: () => ({})
    },
    title: {
     type: String 
    },
    chartKey: {
      type: [String, Number],
      default: 0
    }
  },
  computed: {
    series() {
      return [
        {
          name: 'Total Sales',
          data: this.chartData.map(item => Number(item.total_sales))
        }
      ];
    },
    categories() {
      return this.chartData.map(item => item.name);
    },
    options() {
      return {
        ...this.chartConfig,
        xaxis: {
          ...(this.chartConfig.xaxis || {}),
          categories: this.categories
        }
      };
    }
  }
};
</script>

<template>
  <div class="card">
    <div class="card-header">
      <h5 class="card-title">{{ title ?? 'Top Selling Items' }}</h5>
    </div>
    <div class="card-body">
     <apexchart type="line" height="250" :options="options" :series="series" :key="chartKey"/>
    </div>
  </div>
</template>
